export function counter() {
	const duration = 1500;

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) continue;

				const stat = entry.target;
				if (stat.dataset.counterDone) {
					observer.unobserve(stat);
					continue;
				}
				stat.dataset.counterDone = "1";
				animate(stat);
				observer.unobserve(stat);
			}
		},
		{ threshold: 0.2 }
	);

	document.querySelectorAll("[data-counter]").forEach((el) => observer.observe(el));

	function animate(stat) {
		const el = stat.querySelector("[data-counter-value]");
		const target = +stat.dataset.counter;
		const start = performance.now();
		let last = 0;

		function tick(now) {
			const progress = Math.min((now - start) / duration, 1);
			const val = Math.round(progress * target);

			if (val !== last) {
				el.textContent = val;
				last = val;
			}
			if (progress < 1) requestAnimationFrame(tick);
		}

		requestAnimationFrame(tick);
	}
}
